import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { ProfileModel } from "../models/profile.model";
import { DataService } from "../services/data/data.service";

@Injectable({
  providedIn: "root"
})
export class ConsumerShortdetailsResolverService implements Resolve<ProfileModel> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProfileModel> | Observable<never> {
    const id = route.paramMap.get("consumerId");
    return this.dataService.getConsumerDetails(id).pipe(
      take(1),
      mergeMap(item => {
        if (item && Object.keys(item).length > 0) {
          const consumer: ProfileModel = {
            key: id,
            details: item
          };
          return of(consumer);
        } else {
          // id not found
          return EMPTY;
        }
      })
    );
  }
}
